///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import {
	globalLoadingActionCreators,
	errorManagerActionCreators,
	toastSuccessActionCreators,
	initKioskCreationSummaryActionCreators,
} from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getSummaryCustomer = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSK_CREATION_SUMMARY_CUSTOMER(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationSummaryActionCreators.getSummaryCustomerSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationSummaryActionCreators.getSummaryCustomerFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const setSummaryConfigFinishedCustomer = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.SET_SUMMARY_CONFIG_FINISHED_CUSTOMER(payload.requestId)
	const MsgParams = 'toast__initKiosk__kioskCreation_summary_validateConfig_success'
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(initKioskCreationSummaryActionCreators.setSummaryConfigFinishedCustomerSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationSummaryActionCreators.setSummaryConfigFinishedCustomerFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getSummaryBusiness = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSK_CREATION_SUMMARY_BUSINESS(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationSummaryActionCreators.getSummaryBusinessSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationSummaryActionCreators.getSummaryBusinessFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const setSummaryConfigFinishedBusiness = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.SET_SUMMARY_CONFIG_FINISHED_BUSINESS(payload.requestId)
	const MsgParams = 'toast__initKiosk__kioskCreation_summary_validateConfig_success'
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(initKioskCreationSummaryActionCreators.setSummaryConfigFinishedBusinessSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationSummaryActionCreators.setSummaryConfigFinishedBusinessFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const setSummaryTriggerBuild = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.SET_SUMMARY_TRIGGER_BUILD(payload.requestId)
	const MsgParams = 'toast__initKiosk__kioskCreation_summary_validateBuild_success'
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(initKioskCreationSummaryActionCreators.setSummaryTriggerBuildSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationSummaryActionCreators.setSummaryTriggerBuildFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_KIOSK_CREATION_SUMMARY_CUSTOMER, getSummaryCustomer)
	yield takeLatest(ActionsTypes.SET_SUMMARY_CONFIG_FINISHED_CUSTOMER, setSummaryConfigFinishedCustomer)
	yield takeLatest(ActionsTypes.GET_KIOSK_CREATION_SUMMARY_BUSINESS, getSummaryBusiness)
	yield takeLatest(ActionsTypes.SET_SUMMARY_CONFIG_FINISHED_BUSINESS, setSummaryConfigFinishedBusiness)
	yield takeLatest(ActionsTypes.SET_SUMMARY_TRIGGER_BUILD, setSummaryTriggerBuild)
}

export default sagas
